export const financialSummaryByYearCustomer = (state) => state.financialSummaryByYearCustomer;
export const getIsLoadingFinancialSummary = (state) => state.isLoadingFinancialSummary;
